"use client";

import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";

export function BulkPayoutModal({ children }: { children: React.ReactNode }) {
  const [step, setStep] = useState<"upload" | "preview">("upload");

  return (
    <Dialog>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Bulk Payout Upload</DialogTitle>
          <DialogDescription>
            {step === "upload" ? "Upload a CSV file to process multiple payouts." : "Preview payouts before confirming."}
          </DialogDescription>
        </DialogHeader>
        {step === "upload" ? (
          <div className="space-y-4 py-4">
            <div className="border-2 border-dashed border-border rounded-xl p-8 flex flex-col items-center justify-center text-center hover:bg-muted/50 transition-colors cursor-pointer" onClick={() => setStep("preview")}>
              <Upload className="h-10 w-10 text-muted-foreground mb-4" />
              <h3 className="text-base font-medium mb-1">Click to upload or drag and drop</h3>
              <p className="text-xs text-muted-foreground mb-4">CSV file formatted with Account Number, Bank Code, Amount</p>
              <Button variant="outline" size="sm">Browse Files</Button>
            </div>
          </div>
        ) : (
          <div className="space-y-4 py-4">
            <div className="bg-muted/30 p-3 rounded-lg border text-sm space-y-2">
              <div className="flex justify-between">
                <span className="text-muted-foreground">Valid Records:</span>
                <span className="font-medium">1,245</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Total Amount:</span>
                <span className="font-bold text-primary">₦12,450,000.00</span>
              </div>
            </div>
            <div className="flex gap-3">
              <Button variant="outline" className="flex-1" onClick={() => setStep("upload")}>Back</Button>
              <Button className="flex-1">Confirm & Pay</Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
